import { createAction, props } from '@ngrx/store'
import { Setting } from '../../modules/settings'

export const settingRequested = createAction('[Setting] get', props<{ name: string }>())
export const settingRetrieved = createAction('[Setting] retrieved', props<{ name: string; setting: Setting }>())
export const settingRequestFailed = createAction('[Setting] request failed', props<{ name: string }>())
export const settingModified = createAction('[Setting] modified', props<{ name: string }>())
